import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const series = ['2XX', '3XX', '4XX', '5XX'];
const excludedSeries = (data, series) => data.filter((item) => !series.includes(item));

function EchartsComponent({ option }) {
  const chartRef = useRef(null);
  const filteredItemsRef = useRef(series);

  useEffect(() => {
    let myChart;

    if (chartRef.current) {
      myChart = echarts.init(chartRef.current);
      myChart.setOption(option);

      const handleResize = () => {
        myChart.resize();
      };

      window.addEventListener('resize', handleResize);

      if (option?.tooltip?.trigger === 'axis') {
        myChart.on('mousemove', (param) => {
          const { seriesName, dataIndex } = param || {};
          const excludedList = excludedSeries(series, [seriesName]);
          excludedList.forEach((item) => {
            const element = document.getElementById(`${item}:${dataIndex}`);
            if (element) {
              element.classList.add('chart-opacity');
            }
          });
        });
  
        myChart.on('mouseout', (param) => {
          const { seriesName, dataIndex } = param || {};
          const excludedList = excludedSeries(series, [seriesName]);
          excludedList.forEach((item) => {
            const element = document.getElementById(`${item}:${dataIndex}`);
            if (element) {
              element.classList.remove('chart-opacity');
            }
          });
        });
      }

      if (option?.title) {
          myChart.on('highlight', (ev) => {
            if (ev.name) {
              if (filteredItemsRef.current.includes(ev.name)) {
                myChart.setOption({
                  title: {
                    show: false
                  }
                });
              }
            }
          });
      
        myChart.on('downplay', () => {
            myChart.setOption({
              title: {
                show: true
              }
            });
        });
      
        myChart.on('mouseover', (params) => {
          if (params.componentType === 'series') {
            myChart.setOption({
              title: {
                show: false
              }
            });
          }
        });
      
        myChart.on('mouseout', (params) => {
          if (params.componentType === 'series') {
            myChart.setOption({
              title: {
                show: true
              }
            });
          }
        });

        myChart.on('legendselectchanged', (ev) => {
          const { selected } = ev || {};
          const activeSelections = Object.keys(selected).filter(key => selected[key]) || [];
          const data = option.series?.data || [];
          const filteredData = data.filter(item => activeSelections.includes(item.name));
          const totalSum = filteredData.reduce((acc, curr) => acc + curr.value, 0);

          filteredItemsRef.current = activeSelections;
        
          myChart.setOption({
            title: {
              text: `{a|Total}\n{b|${totalSum}}`,
            }
          });
      
        });
      }


      return () => {
        window.removeEventListener('resize', handleResize);
        myChart.dispose();
      };
    }

    return undefined;
  }, [option]);

  useEffect(() => {
    filteredItemsRef.current = series;
  }, [option?.title]);

  return <div ref={chartRef} style={{ width: '100%', height: '400px' }} />;
}

export default EchartsComponent;